// Badge of the camera's "Get text from photo" action (Figma node 16658:17518). The three text lines sit half a pixel
// higher than in Figma: there they are 1px strokes on whole coordinates, which a 1x screen smears into one light band.
const BADGE_FILL = { fill: 'var(--color-primary-main)' };
const BADGE_LINES = { stroke: 'var(--color-white)' };

const OcrTextScanIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
        <rect width="14" height="14" rx="7" style={BADGE_FILL} />
        <g style={BADGE_LINES} strokeLinecap="round" strokeLinejoin="round">
            <path d="M2.5 4.5V3.5C2.5 3.23478 2.60536 2.98043 2.79289 2.79289C2.98043 2.60536 3.23478 2.5 3.5 2.5H4.5" />
            <path d="M9.5 2.5H10.5C10.7652 2.5 11.0196 2.60536 11.2071 2.79289C11.3946 2.98043 11.5 3.23478 11.5 3.5V4.5" />
            <path d="M11.5 9.5V10.5C11.5 10.7652 11.3946 11.0196 11.2071 11.2071C11.0196 11.3946 10.7652 11.5 10.5 11.5H9.5" />
            <path d="M4.5 11.5H3.5C3.23478 11.5 2.98043 11.3946 2.79289 11.2071C2.60536 11.0196 2.5 10.7652 2.5 10.5V9.5" />
            <path d="M4.5 4.5H8.5" />
            <path d="M4.5 6.5H9.5" />
            <path d="M4.5 8.5H7.5" />
        </g>
    </svg>
);

export default OcrTextScanIcon;
